import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import * as dayjs from 'dayjs';
import { CallerReportService } from '../../services/caller-report/caller-report.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
	selector: 'app-caller-reports',
	templateUrl: './caller-reports.component.html',
	styleUrls: ['./caller-reports.component.scss'],
})
export class CallerReportsComponent implements OnInit {
	@ViewChild(DatatableComponent) table: DatatableComponent;

	temp = [];
	rows = [];
	ColumnMode = ColumnMode;
	dateRange_;

	// CHART PIE

	simplePieChart: any;
	lineWithDataLabelsChart: any;

	fromDate: string = '';
	toDate: string = '';

	totalDispos: any;

	constructor(
		private calendar: NgbCalendar,
		public utils: UtilsService,
		public callerReportSrv: CallerReportService,
	) {
		this.totalDispos = null;
		this.simplePieChart = {
			series: [20, 20, 20, 20, 20],
			chart: {
				height: 500,
				type: 'pie',
			},
			labels: ['Bad Phone', 'No Answer', 'Callback', 'Lead', 'Other'],
			colors: ['#3F475D', '#40A0FC', '#FEBC4A', '#50E7A6', '#FE4560'],
			legend: {
				position: 'bottom',
			},
			dataLabels: {
				dropShadow: {
					enabled: true,
				},
			},
		};

		this.lineWithDataLabelsChart = {
			chart: {
				height: 380,
				type: 'line',
				zoom: {
					enabled: false,
				},
				toolbar: {
					show: false,
				},
			},
			colors: '["--vz-primary", "--vz-success", "--vz-warning", "--vz-danger", "--vz-info"]',
			dataLabels: {
				enabled: false,
			},
			stroke: {
				width: [3, 3],
				curve: 'straight',
			},
			series: [
				{
					name: 'High - 2018',
					data: [26, 24, 32, 36, 33, 31, 33],
				},
				{
					name: 'Low - 2018',
					data: [14, 11, 16, 12, 17, 13, 12],
				},
			],
			title: {
				text: 'Calls in Time',
				align: 'left',
				style: {
					fontWeight: 500,
				},
			},
			grid: {
				row: {
					colors: ['transparent', 'transparent'],
					opacity: 0.2,
				},
				borderColor: '#f1f1f1',
			},
			markers: {
				size: 6,
			},
			xaxis: {
				categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
				title: {
					text: 'Month',
				},
			},
			yaxis: {
				title: {
					text: 'Temperature',
				},
				min: 5,
				max: 40,
			},
			legend: {
				position: 'top',
				horizontalAlign: 'right',
				floating: true,
				offsetY: -25,
				offsetX: -5,
			},
		};

		this.fromDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD') + ' 00:00:00';
		this.toDate = dayjs().format('YYYY-MM-DD') + ' 23:59:59';

		this.dateRange_ = {
			dateStart: dayjs().subtract(1, 'month'),
			dateEnd: dayjs(),
		};
	}

	ngOnInit() {
		this.getAllTimes();
	}

	updateFilter2(event, props: string) {
		const val = event.target.value.toLowerCase();
		const propArray = props.split(',');
		// filter our data
		const temp = this.temp.filter(function (d) {
			// Verifica si alguna de las propiedades contiene el valor buscado
			return propArray.some((prop) => {
				return d[prop].toLowerCase().indexOf(val) !== -1 || !val;
			});
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	dateSelected(dates: any) {
		this.fromDate = dayjs(dates.dateStart).format('YYYY-MM-DD') + ' 00:00:00';
		this.toDate = dayjs(dates.dateEnd).format('YYYY-MM-DD') + ' 23:59:59';
		this.getAllTimes();
	}

	getAllTimes() {
		// TODO: This call to ring central is blocked for now because is callin several times to the backend we will fix this call saving the info in our DB
		console.info('This call to ring central is blocked for now because is callin several times to the backend we will fix this call saving the info in our DB');
		// this.callerReportSrv.get_all_callers_times(this.fromDate, this.toDate).subscribe((data: any)=>{
		// 	this.rows = data.body;
		// 	this.temp = [...this.rows];
		// 	this.simplePieChart.series = this.calculatePercentagesDispos(this.calculateTotalsDispos(data.body));
		// })
	}

	calculateTotalsDispos(data) {
		const totals = data.reduce(
			(acc, item) => {
				acc.totalDispos += parseInt(item.totalDispos);
				acc.black += parseInt(item.black);
				acc.blue += parseInt(item.blue);
				acc.yellow += parseInt(item.yellow);
				acc.green += parseInt(item.green);
				acc.other += parseInt(item.other);
				return acc;
			},
			{ totalDispos: 0, black: 0, blue: 0, yellow: 0, green: 0, other: 0 },
		);

		return totals;
	}

	calculatePercentagesDispos(data) {
		const percentages = {};
		const { totalDispos } = data; // Destructuring para obtener el total de disposiciones

		for (const key in data) {
			if (data.hasOwnProperty(key) && key !== 'totalDispos') {
				// Calcular el porcentaje y redondear al segundo decimal
				percentages[key] = parseFloat(((data[key] / totalDispos) * 100).toFixed(2));
			}
		}

		return [percentages['black'], percentages['blue'], percentages['yellow'], percentages['green'], percentages['other']];
	}

	sumValues(cells: string[]) {
		const filteredCells = cells.filter((cell) => !!cell);
		return filteredCells.reduce((sum: any, cell) => (sum += parseInt(cell)), 0);
	}

	sumHours(cells: string[]) {
		const filteredCells = cells.filter((cell) => !!cell);
		const result = filteredCells.reduce((sum: any, cell) => (sum += parseInt(cell)), 0);
		const seconds = result / 1000;

		// Determinar el formato a aplicar
		if (seconds < 60) {
			// Menos de 1 minuto
			return `${Math.floor(seconds)}s`;
		} else if (seconds < 3600) {
			// Menos de 1 hora, convertir a minutos
			return `${Math.floor(seconds / 60)}m`;
		} else {
			// Horas
			return `${Math.floor(seconds / 3600)}h`;
		}
	}
}
